// const baseUrl = "http://localhost:8201";
// const baseUrl = "https://instructor.teachera.co";
const localUrl = "http://localhost:3009";
const baseUrl = "https://api.onlinevaishnav.com";
export { baseUrl, localUrl };

//perchese
//active InActive in videoList
